"use strict";

class PropertyKeyHandoverSettingsController {

    constructor($scope, $parse, $timeout, $sce, SSHttpService, SSAwsService, SSConfigService, SSUtilService, SSDateService, SSAlertService, SSUserService, OTPService, SSConfirmationService, SSAppService, SSKeyHandoverScheduleService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;
        self.$timeout = $timeout;
        self.$sce = $sce;

        self.SSHttpService = SSHttpService;
        self.SSAwsService = SSAwsService;
        self.SSConfigService = SSConfigService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSAppService = SSAppService;
        self.SSKeyHandoverScheduleService = SSKeyHandoverScheduleService;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;
        self.EDITOR_API_KEY = SHOWSUITE.data.EDITOR_API_KEY;
        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        self.APPOINTMENT_APPROVAL_REQUIRED_ALL_APPOINTMENTS = SHOWSUITE.APPOINTMENT_APPROVAL_REQUIRED_ALL_APPOINTMENTS;
        self.APPOINTMENT_APPROVAL_REQUIRED_REPRESENTATIVE_ONLY = SHOWSUITE.APPOINTMENT_APPROVAL_REQUIRED_REPRESENTATIVE_ONLY;

        self.APPOINTMENT_FILE_TYPE_LETTER_OF_AUTHORISATION = SHOWSUITE.APPOINTMENT_FILE_TYPE_LETTER_OF_AUTHORISATION;
        self.APPOINTMENT_FILE_TYPE_OTHERS = SHOWSUITE.APPOINTMENT_FILE_TYPE_OTHERS;

        self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_BOOKING_SUBMISSION = SHOWSUITE.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_BOOKING_SUBMISSION;
        self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_CONFIRMATION = SHOWSUITE.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_CONFIRMATION;
        self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_UPDATED = SHOWSUITE.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_UPDATED;
        self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_EXPIRY = SHOWSUITE.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_EXPIRY;
        self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_RESCHEDULE = SHOWSUITE.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_RESCHEDULE;
        self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_CANCELED = SHOWSUITE.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_CANCELED;
        self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_UNIT_READY = SHOWSUITE.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_UNIT_READY;

        /**
         * WEB-4210: Buyer(s) Email Notifications copy setting. The developer may opt to
         * receive a copy of every enabled buyer notification, as CC or BCC. Stored in
         * key_handover_settings.value.email_notifications; the server mirrors these values
         * (see KeyHandoverAppointmentService::parseEmailNotificationCopySetting()).
         */
        self.EMAIL_COPY_TYPE_CC = 'cc';
        self.EMAIL_COPY_TYPE_BCC = 'bcc';
        self.EMAIL_COPY_MAX_RECIPIENTS = 10;

        /**
         * WEB-4480: free-text length limits, the same as the app (WEB-4440). The server stores
         * key_handover_settings as one JSON value and checks none of these fields, so both
         * clients enforce them on save.
         */
        self.CONTACT_NAME_MAX_LENGTH = 100;
        self.CONTACT_EMAIL_MAX_LENGTH = 254;
        self.CONTACT_PHONE_MAX_LENGTH = 30;
        self.EXTERNAL_LINK_MAX_LENGTH = 2048;
        self.DOCUMENT_NAME_MAX_LENGTH = 100;
        self.EMAIL_COPY_MAX_LENGTH = 254;
        /** PHP's FILTER_VALIDATE_EMAIL rejects more than 64 characters before the @ */
        self.EMAIL_LOCAL_PART_MAX_LENGTH = 64;


        self.event_registration_banner_image = null;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.editor = null;

        self.timeZones = self.SSConfigService.getTimeZones();

        self.initDocumentTypes();
        self.initDocumentRoles();
        self.initEmailTemplateConstants();

        /** WEB-4210: seeded properly once the property settings load */
        self.emailCopySettings = self.normalizeEmailCopySettings(null);
        self.emailCopySettingsErrors = {};

        self.getEmailSettings();
        self.getPropertySettings();

        self.$timeout(function(){
            // https://api.jqueryui.com/datepicker/#option-minDate
            $('.date-input').datepicker({dateFormat: "dd/mm/yy"});
            $('.date-input').datepicker("option", "minDate", new Date());
        });
    }


    // ----------- GENERAL SETTINGS SECTION  -------

    getPropertySettings() {
        const self = this;

        let url = 'sec/developer/properties/'+ self.property.id +'/settings';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.property_settings){

                // Get Key Handover Settings
                self.key_handover_settings = self.getSetting(response.data.property_settings, 'key_handover_settings');


                if(self.key_handover_settings){
                    /**
                     * WEB-4818: times are shown in the project's timezone, not the browser's, as
                     * in the DMS app. The zone is remembered so the save converts back with the
                     * same one, even when General Settings changes the timezone in the meantime.
                     */
                    self.loadedTimeZoneId = self.SSKeyHandoverScheduleService.timeZoneId(self.key_handover_settings.value);

                    if(self.key_handover_settings.value && self.key_handover_settings.value.special_days){
                        $.each(self.key_handover_settings.value.special_days, function(index, special_day){
                            if(special_day.date){
                                /** WEB-4312: tolerate a day-first stored date instead of turning it into "Invalid date". */
                                special_day.date = self.SSDateService.formatSettingsDateAsDayFirst(special_day.date);
                            }
                            self.convertSlotTimes(special_day.slots, true);
                        });
                    }

                    if(self.key_handover_settings.value && self.key_handover_settings.value.week_days){
                        $.each(self.key_handover_settings.value.week_days, function(index, day){
                            self.convertSlotTimes(day.slots, true);
                        });
                    }

                    if(self.key_handover_settings.value && self.key_handover_settings.value.approval_required){
                        self.approval_required_value = self.key_handover_settings.value.approval_required;
                        self.key_handover_settings.value.approval_required = true;
                    }
                    else{
                        self.approval_required_value = self.APPOINTMENT_APPROVAL_REQUIRED_ALL_APPOINTMENTS;
                        self.key_handover_settings.value.approval_required = false;
                    }

                    /**
                     * WEB-3538: every map sub-key must always be a map ({}) — never an array ([])
                     * or null. The previous falsy-only guards missed empty arrays ([] is truthy in
                     * JS), leaving legacy [] shapes in place. Normalise all map fields in one place
                     * so the load / edit / save paths cannot drift (extends WEB-3406's external_links fix).
                     */
                    self.normalizeMapSettings(self.key_handover_settings.value);

                }
                else{
                    self.key_handover_settings = self.getDefaultSettings();
                    self.loadedTimeZoneId = null;
                }

                self.otp_verification_rescan = self.key_handover_settings.value.otp_verification_rescan? true : false;
                self.otp_verification_relaunch = self.key_handover_settings.value.otp_verification_relaunch? true : false;

                /** WEB-4304: count the Max. Appointment Days window from the unit's Mark Ready date */
                self.max_appointment_days_from_ready_date =
                    self.key_handover_settings.value.max_appointment_days_from_ready_date? true : false;

                self.buyer_docs_visible = self.key_handover_settings.value.buyer_docs_visible? true : false;
                self.representative_docs_visible = self.key_handover_settings.value.representative_docs_visible? true : false;

                self.key_handover_settings.value.nric_passport_buyer = self.key_handover_settings.value.nric_passport_buyer? true : false;
                self.key_handover_settings.value.nric_passport_buyer_required = self.key_handover_settings.value.nric_passport_buyer_required? true : false;
                self.key_handover_settings.value.nric_passport_buyer_four_character = self.key_handover_settings.value.nric_passport_buyer_four_character? true : false;
                self.key_handover_settings.value.nric_passport_authroised_officer = self.key_handover_settings.value.nric_passport_authroised_officer? true : false;
                self.key_handover_settings.value.nric_passport_authroised_officer_required = self.key_handover_settings.value.nric_passport_authroised_officer_required? true : false;
                self.key_handover_settings.value.nric_passport_authroised_officer_four_character = self.key_handover_settings.value.nric_passport_authroised_officer_four_character? true : false;

                /**
                 * WEB-4224: Buyer Validation switch. Persisted as 1/0 (see getKeyHandoverSettingsParams),
                 * absent on every project that predates the feature — coerce to a real boolean so the
                 * ng-model checkbox binds cleanly and the display state never shows a bare 0/1.
                 */
                self.key_handover_settings.value.buyer_validation_enabled = self.key_handover_settings.value.buyer_validation_enabled? true : false;


                /** WEB-2906 Keyhandover : DMS : Address Optional and Mandatory Support **/
                if(self.key_handover_settings.value.address_setting){
                    if(self.key_handover_settings.value.address_setting === 10){
                        self.show_address = false;
                        self.show_address_required = false;
                    } else if(self.key_handover_settings.value.address_setting === 20){
                        self.show_address = true;
                        self.show_address_required = false;
                    } else if(self.key_handover_settings.value.address_setting === 30){
                        self.show_address = true;
                        self.show_address_required = true;
                    }
                } else{
                    self.show_address = false;
                    self.show_address_required = false;
                }

                self.key_handover_settings.value.buyer_data_visible_during_edit_appointment = self.key_handover_settings.value.buyer_data_visible_during_edit_appointment? true : false;
                self.key_handover_settings.value.buyer_data_visible_during_edit_particulars = self.key_handover_settings.value.buyer_data_visible_during_edit_particulars? true : false;
                if(self.key_handover_settings.value.event_registration.enable &&
                    self.key_handover_settings.value.event_registration.banner_image_file_uri){
                    self.banner_image_file_url = self.SSAppService.getAssetUrl(self.key_handover_settings.value.event_registration.banner_image_file_uri);
                }

                /** WEB-4210: read-only view of the Buyer(s) Email Notifications copy setting */
                self.emailCopySettings = self.getEmailCopySettings();
            }
        });
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        let parent = jQuery;
        if (formId) {
            parent = jQuery('#' + formId);
        }

        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }

            field.on("keyup change", function () {

                field.parent().removeClass("has-error");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));
                field.parent().removeClass("has-error");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-error");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                    }
                } else {
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }

    getSetting(settings, setting_name){
        const self = this;

        if(!(settings || setting_name)){
            return null;
        }

        let setting = {};

        try{
            setting = settings.find(x => x.name == setting_name);

            if(setting && setting.value){
                if(typeof setting.value == "string"){
                    setting.value = JSON.parse(setting.value);
                }
                else{
                    setting.value = setting.value;
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

        return setting;
    }

    // ---------  Key Handover Settings Section: START  -------

    editKeyHandoverSettings(editMode, editType){
        const self = this;

        self.editType = editType;
        self.settingsEditMode = {};
        self.keyHandoverSettingsParams = {};
        self.keyHandoverSettingsErrors = {};

        if(editMode){
            if(self.key_handover_settings){
                self.keyHandoverSettingsParams = angular.copy(self.key_handover_settings);

                /** WEB-3538: keep every map sub-key as {} (never []) in the edit buffer */
                self.normalizeMapSettings(self.keyHandoverSettingsParams.value);

                if(editType == 'DAY_TIME_SETTINGS'){
                    // If 'slot_times' are empty then initialize with default data
                    if(!self.keyHandoverSettingsParams.value.slot_times){
                        self.keyHandoverSettingsParams.value.slot_times = [];
                        self.keyHandoverSettingsParams.value.slot_times.push({start_time: null, end_time: null});
                    }
                    /**
                     * WEB-4818: Special Days replace Blackout Days. No empty row is added — a
                     * project may have none — and `blackout_days` is no longer read or written.
                     */
                    if(!Array.isArray(self.keyHandoverSettingsParams.value.special_days)){
                        self.keyHandoverSettingsParams.value.special_days = [];
                    }
                }
            }
            else{
                self.keyHandoverSettingsParams = self.getDefaultSettings();
            }

            if(editType == 'GENERAL_SETTINGS'){
                // Minimum slot period is 60 minutes
                if(self.keyHandoverSettingsParams.value && !self.keyHandoverSettingsParams.value.slot_period){
                    self.keyHandoverSettingsParams.value.slot_period = 60;
                }

                /**
                 * WEB-4304: re-seed the switch from the saved settings on every entry into edit mode,
                 * so a toggle that was abandoned with Cancel is not carried into the next save
                 * (getKeyHandoverSettingsParams() always serialises the whole blob).
                 */
                self.max_appointment_days_from_ready_date =
                    self.key_handover_settings
                    && self.key_handover_settings.value
                    && self.key_handover_settings.value.max_appointment_days_from_ready_date? true : false;

                if(self.keyHandoverSettingsParams.value.mobile_app_time_zone){
                    self.keyHandoverSettingsParams.value.mobile_app_time_zone = self.timeZones.find(x => x.id == self.keyHandoverSettingsParams.value.mobile_app_time_zone.id);
                }

                self.$timeout(function() {
                    $("select.tz-select").niceSelect('update');
                });
            }

            if(editType == 'DAY_TIME_SETTINGS'){
                $.each(self.keyHandoverSettingsParams.value.week_days, function(index, day){
                    day.closed = day.closed? true : false;
                    day.slots = day.closed || !day.slots || !day.slots.length? [{start_time: null, end_time: null}] : day.slots;
                });

                /** WEB-4818: the switch reads On/Off; an absent `closed` means Off, the default */
                $.each(self.keyHandoverSettingsParams.value.special_days, function(index, special_day){
                    special_day.closed = self.SSKeyHandoverScheduleService.isSpecialDayOff(special_day);
                    if(!special_day.slots || !special_day.slots.length){
                        special_day.slots = [{start_time: null, end_time: null}];
                    }
                });
            }

            if(editType == 'DOCUMENTS_SETTINGS'){
                if(!self.keyHandoverSettingsParams.value.documents || !self.keyHandoverSettingsParams.value.documents.length)
                    self.keyHandoverSettingsParams.value.documents = [{}]
            }

            if(editType == 'EXTERNAL_LINKS_SETTINGS'){
                /** WEB-3538: external_links shape is normalised by normalizeMapSettings() above (was WEB-3406) */
                self.isValidUrl = true;
                self.externalLinkSettingsErrors = {};
            }

            /**
             * WEB-4480: mask only once Angular has linked the inputs. This used to also run from
             * getPropertySettings() in the constructor, where intl-tel-input wrapped the phone
             * input before linking, so ng-model attached to the wrapper and only ever read ''.
             * A phone the plugin calls invalid was then saved empty, and its length went unchecked.
             */
            self.$timeout(function() {
                self.maskPhoneNumber(self, 'ctrl.');
            });

        }
        if(!editMode && editType == 'EVENT_REGISTRATION'){
            if(self.event_registration_banner_image){
                self.key_handover_settings.value.event_registration.banner_image_file_uri = self.event_registration_banner_image;
                self.banner_image_file_url = self.SSAppService.getAssetUrl(self.event_registration_banner_image);
            }
        }

        self.settingsEditMode[editType] = editMode;

        if(editMode && editType == 'DAY_TIME_SETTINGS'){

            if(editMode && !self.keyHandoverSettingsParams.value.week_days){
                let week_days = [
                    {id: 0, name: 'Sunday', closed: 1, slots:[]},
                    {id: 1, name: 'Monday', closed: 0, slots:[{start_time: null, end_time: null}]},
                    {id: 2, name: 'Tuesday', closed: 0, slots:[{start_time: null, end_time: null}]},
                    {id: 3, name: 'Wednesday', closed: 0, slots:[{start_time: null, end_time: null}]},
                    {id: 4, name: 'Thursday', closed: 0, slots:[{start_time: null, end_time: null}]},
                    {id: 5, name: 'Friday', closed: 0, slots:[{start_time: null, end_time: null}]},
                    {id: 6, name: 'Saturday', closed: 0, slots:[{start_time: null, end_time: null}]}
                ];

                self.keyHandoverSettingsParams.value.week_days = week_days;
            }

            self.$timeout(function(){
                $.each(self.keyHandoverSettingsParams.value.special_days, function(index, special_day){
                    if($(".sd_"+ index).length){
                        $(".sd_"+ index).datepicker("option", "dateFormat", "dd/mm/yy");
                        $(".sd_"+ index).datepicker("setDate", special_day.date);
                    }
                });
            });
        }

    }

    editEmailSettings(editMode){
        const self = this;

        self.emailSettingsEditMode = editMode;
        self.emailCopySettingsErrors = {};

        if(editMode){
            self.emailTemplateParams = angular.copy(self.email_templates);

            /**
             * WEB-4210: edit against a copy of the stored copy setting, so Cancel discards
             * the edits the same way it already does for the template list.
             */
            self.emailCopySettingsParams = angular.copy(self.emailCopySettings);
        }
    }

    /**
     * WEB-4210: The stored Buyer(s) Email Notifications copy setting, in UI shape.
     *
     * @returns {{enabled: boolean, type: string, emails: string}}
     *
     * @remarks The block can legitimately come back as [] rather than {} on a project that
     *          never configured it — [] is truthy in JS, so the Array check is what keeps
     *          the legacy shape from being read as a configured object (WEB-3538).
     */
    getEmailCopySettings(){
        const self = this;

        let value = self.key_handover_settings? self.key_handover_settings.value : null;
        let stored = (value && value.email_notifications && !Array.isArray(value.email_notifications))?
            value.email_notifications : null;

        if(!stored) return self.normalizeEmailCopySettings(null);

        return self.normalizeEmailCopySettings({
            enabled: stored.copy_enabled,
            type: stored.copy_type,
            emails: stored.copy_emails
        });
    }

    /**
     * WEB-4210: Canonical form of the copy setting — used both for display and for the
     * change check, so that re-saving without touching the block is recognised as a no-op.
     *
     * @param {{enabled: *, type: *, emails: *}|null} copySettings raw/edited values
     * @returns {{enabled: boolean, type: string, emails: string}} trimmed, lowercased,
     *          de-duplicated; type falls back to CC for any unrecognised value, matching
     *          the server. Addresses are kept even when the switch is off, so turning it
     *          back on does not cost the developer the list they already entered.
     */
    normalizeEmailCopySettings(copySettings){
        const self = this;

        let type = (copySettings && copySettings.type)? String(copySettings.type).trim().toLowerCase() : '';

        let emails = (copySettings && copySettings.emails)? String(copySettings.emails) : '';
        emails = emails.split(',')
            .map(function(email){ return email.trim().toLowerCase(); })
            .filter(function(email){ return email.length > 0; });
        emails = emails.filter(function(email, index){ return emails.indexOf(email) === index; });

        return {
            enabled: (copySettings && copySettings.enabled)? true : false,
            type: (type === self.EMAIL_COPY_TYPE_BCC)? self.EMAIL_COPY_TYPE_BCC : self.EMAIL_COPY_TYPE_CC,
            emails: emails.join(',')
        };
    }

    /**
     * WEB-4210: Validate the copy setting inputs before saving.
     *
     * @returns {boolean} false when the switch is on but the address list is empty, too
     *          long, or contains an address that is not a valid email. Populates
     *          self.emailCopySettingsErrors for display.
     */
    isValidEmailCopySettingsInput(){
        const self = this;

        self.emailCopySettingsErrors = {};

        let params = self.emailCopySettingsParams;
        if(!params || !params.enabled) return true;

        let emails = (params.emails? String(params.emails) : '').split(',')
            .map(function(email){ return email.trim(); })
            .filter(function(email){ return email.length > 0; });

        if(!emails.length){
            self.emailCopySettingsErrors.emails = "Please enter at least one email address.";
            return false;
        }

        if(emails.length > self.EMAIL_COPY_MAX_RECIPIENTS){
            self.emailCopySettingsErrors.emails = "Maximum "+ self.EMAIL_COPY_MAX_RECIPIENTS +" email addresses allowed.";
            return false;
        }

        let invalidEmails = emails.filter(function(email){
            return !self.SSUtilService.validateEmail(email);
        });

        if(invalidEmails.length){
            self.emailCopySettingsErrors.emails = "Please enter valid email(s): "+ invalidEmails.join(', ');
            return false;
        }

        /** WEB-4480 */
        if(emails.some(function(email){ return self.exceedsMaxLength(email, self.EMAIL_COPY_MAX_LENGTH); })){
            self.emailCopySettingsErrors.emails = self.maxLengthMessage(self.EMAIL_COPY_MAX_LENGTH);
            return false;
        }

        /** WEB-4480: the server silently drops a recipient it cannot validate, so the copy would never be sent */
        let longLocalPart = emails.find(function(email){ return self.exceedsEmailLocalPartLength(email); });
        if(longLocalPart){
            self.emailCopySettingsErrors.emails = self.localPartMessage() +" "+ longLocalPart;
            return false;
        }

        return true;
    }

    /**
     * WEB-4480: length in user-perceived characters, the way the app (WEB-4440) counts them,
     * so the two clients accept and reject the same values.
     */
    textLength(value){
        if(value === undefined || value === null) return 0;

        value = String(value);
        if(typeof Intl !== 'undefined' && Intl.Segmenter){
            return Array.from(new Intl.Segmenter().segment(value)).length;
        }
        return Array.from(value).length;
    }

    /**
     * WEB-4480: the Contact Details phone must be a number intl-tel-input accepts. Until the
     * ng-model fix this was implicit: an invalid number never reached the model, so it was saved
     * blank. Now the model holds what was typed, so the check has to be explicit.
     */
    isValidContactPhone(){
        let field = jQuery('input[type=tel][ng-model="ctrl.keyHandoverSettingsParams.value.contact_details.phone"]');

        if(!field.length || !field.data('plugin_intlTelInput')) return true;
        return field.intlTelInput('isValidNumber');
    }

    exceedsMaxLength(value, max){
        return this.textLength(value) > max;
    }

    maxLengthMessage(max){
        return "Please enter no more than "+ max +" characters.";
    }

    exceedsEmailLocalPartLength(email){
        email = email? String(email).trim() : '';

        let at = email.lastIndexOf('@');
        if(at < 0) return false;
        return this.exceedsMaxLength(email.substring(0, at), this.EMAIL_LOCAL_PART_MAX_LENGTH);
    }

    localPartMessage(){
        return "The part before the @ can be at most "+ this.EMAIL_LOCAL_PART_MAX_LENGTH +" characters.";
    }

    validateUrl(url, type) {
        const self = this;

        self.isValidUrl = true;
        self.externalLinkSettingsErrors = {};

        if(!url) return;

        self.isValidUrl = /^(http(s)?:\/\/)?(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(url);

        if(!self.isValidUrl)
            self.externalLinkSettingsErrors[type] = "Please enter valid url.";
    }

    getEmailSettings(){
        const self = this;

        self.email_templates = [];
        let url = 'sec/developer/email-templates';
        let params = {
            property_id: self.property.id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.email_templates){
                let templates = [];

                self.email_templates = response.data.email_templates;

                $.each(self.emailTemplateTypes, function(index, obj){
                    let template = self.email_templates.find(x => x.type == obj.id);
                    if(template){
                        template.name = obj.name;
                        template.is_enabled = template.is_enabled? true : false;
                        templates.push(template);
                    }
                    else{
                        templates.push({
                            type: obj.id,
                            name: obj.name,
                            is_enabled: false,
                            property_id: self.property.id,
                        });
                    }
                });

                self.email_templates = templates;
            }
        });
    }

    editEmailTemplate(template){
        const self = this;

        self.emailTemplate = template;
        self.contents = angular.copy(template.contents);

        // Init Froala Editor
        self.editor = new FroalaEditor('#froala-editor', {
            key: self.EDITOR_API_KEY,
            charCounterCount: false,
            placeholderText: ''

        }, function(){
        });

        $('#emailTemplateModal').modal('show');

        self.$timeout(function () {
            self.editor.html.set(self.contents);
            self.$scope.$apply();
        });
    }

    updateTemplate(){
        const self = this;

        let contents = new FroalaEditor('#froala-editor').html.get(true);
        self.emailTemplate.contents = contents;

        $('#emailTemplateModal').modal('hide');
    }

    isRecordUpdated(template){
        const self = this;

        let isUpdated = false;

        if(!template) return;

        let _template = self.email_templates.find(x => x.id == template.id);

        if(_template){
            if(template.is_enabled != _template.is_enabled)
                isUpdated = true;
            else if(template.contents != _template.contents)
                isUpdated = true;
        }

        template.is_updated = isUpdated;

        return isUpdated;
    }

    toggleSelection(day, index){
        const self = this;

        $.each(self.keyHandoverSettingsParams.value.week_days, function(i, _day){
            if(i == index){
                _day.closed = !event.target.checked;
                _day.slots = [{start_time: null, end_time: null}];
                return;
            }
        });
    }

    uploadLetter(files, index){
        const self = this;

        let uri = self.keyHandoverSettingsParams.value.documents[index].file_uri;

        if (!files || files.length < 1) return;
        let file = files[0];
        let fileFormat = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            fileFormat = "pdf";
        } else if (file.type.indexOf("image") !== -1) {
            fileFormat = "image";
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let policyUrl = 'sec/developer/key-handover/appointments/s3-policy-document?property_id='+self.property.id;

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(!self.keyHandoverSettingsParams.value.documents[index])
                self.keyHandoverSettingsParams.value.documents[index] = {};

            self.keyHandoverSettingsParams.value.documents[index].file_uri = response.config.data.key;

            self.keyHandoverSettingsParams.value.documents[index].name = file.name.split('.')[0];
            self.keyHandoverSettingsParams.value.documents[index].format = fileFormat;

        });
    }

    getFileName(file, fileExtension){
        const self = this;

        if(!file) return null;

        let fileName = null;

        if(file.includes('/')){
            let params = file.split('/');
            if(params) {
                fileName = params.pop();
                if(fileExtension && !fileName.includes(fileExtension)){
                    fileName = fileName.split('.')[0] + '.' + fileExtension;
                }
            }
        }

        return fileName;
    }

    /**
     * Save the Buyer(s) Email Notifications card.
     *
     * @remarks WEB-4210 — this card now saves two independent things: the copy setting
     *          (a property setting) and the email templates. The copy setting goes first
     *          because it is the one that can be rejected on permissions; the templates
     *          follow only once it has landed, so a half-save cannot report success.
     */
    saveEmailSettings(){
        const self = this;

        if(!self.isValidEmailCopySettingsInput()){
            return;
        }

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self._saveEmailCopySettings(function(){
                self._saveEmailTemplates();
            });
        });
    }

    /**
     * WEB-4210: Persist the copy setting, then continue.
     *
     * @param {function} onDone called once the setting is stored — or immediately when it
     *        did not change. Not called when the save fails, so the card stays open on the
     *        user's edits instead of silently reporting success.
     *
     * @remarks Two things this must get right:
     *          - Skipping the request when nothing changed is not just an optimisation:
     *            POST properties/{id}/settings additionally requires DMS_EDIT_PROJ_SET,
     *            and a user who only toggles templates must not start hitting a permission
     *            error on a card that used to work for them.
     *          - That endpoint replaces the WHOLE key_handover_settings value, so the
     *            payload is built through getKeyHandoverSettingsParams() like every other
     *            settings card. Posting key_handover_settings.value directly would write
     *            back the display-mutated week-day/special-day times and approval_required
     *            that getPropertySettings() rewrote for rendering.
     */
    _saveEmailCopySettings(onDone){
        const self = this;

        let copySettings = self.normalizeEmailCopySettings(self.emailCopySettingsParams);

        if(angular.equals(copySettings, self.emailCopySettings)){
            onDone();
            return;
        }

        /**
         * getKeyHandoverSettingsParams() reads and rewrites self.keyHandoverSettingsParams,
         * which is also the edit buffer of the other settings cards. This card has its own
         * edit flag, so another card can legitimately be open at the same time — borrow the
         * buffer and hand it straight back rather than discarding those unsaved edits.
         */
        let previousSettingsParams = self.keyHandoverSettingsParams;

        self.keyHandoverSettingsParams = angular.copy(self.key_handover_settings || self.getDefaultSettings());
        self.normalizeMapSettings(self.keyHandoverSettingsParams.value);
        self.keyHandoverSettingsParams.value.email_notifications = {
            copy_enabled: copySettings.enabled? 1 : 0,
            copy_type: copySettings.type,
            copy_emails: copySettings.emails
        };

        let url = 'sec/developer/properties/'+ self.property.id +'/settings';
        let params = self.getKeyHandoverSettingsParams();

        self.keyHandoverSettingsParams = previousSettingsParams;

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            onDone();
        });
    }

    /**
     * WEB-4210: Save the templates the user actually changed.
     *
     * @remarks Split out of saveEmailSettings(). A copy-setting-only edit leaves no
     *          template dirty, and the old code's counter loop simply did nothing in that
     *          case — leaving the card stuck open with no feedback. Finish explicitly instead.
     */
    _saveEmailTemplates(){
        const self = this;

        self.updated_records_index = 0;
        self.updated_templates_count = self.emailTemplateParams.filter(x => x.is_updated).length;

        if(!self.updated_templates_count){
            self.finishEmailSettingsSave();
            return;
        }

        $.each(self.emailTemplateParams, function(i, params){
            if(params.is_updated){
                params.is_enabled = params.is_enabled? 1 : 0;
                self._saveEmailSettings(params);
            }
        });
    }

    /**
     * WEB-4210: Close the card and refresh what it displays.
     *
     * @remarks getPropertySettings() is reloaded alongside the templates because the copy
     *          setting is rendered from key_handover_settings, not from the template rows.
     */
    finishEmailSettingsSave(){
        const self = this;

        self.getEmailSettings();
        self.getPropertySettings();
        self.emailSettingsEditMode = false;
        self.SSAlertService.success('Success!', 'Email settings updated successfully.');
    }

    _saveEmailSettings(params){
        const self = this;

        let url = 'sec/developer/email-templates';

        let handleResponse = function (response) {
            loading(false);
            self.updated_records_index++;

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(self.updated_records_index == self.updated_templates_count){
                self.finishEmailSettingsSave();
            }
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
    }

    saveKeyHandoverSettings(type){
        const self = this;

        self.editType = type;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self._saveKeyHandoverSettings();
        });
    }

    _saveKeyHandoverSettings(){
        const self = this;

        if(!self.isValidSettingsInput()){
            return;
        }

        let url = 'sec/developer/properties/'+ self.property.id +'/settings';

        let params = self.getKeyHandoverSettingsParams();

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                /** WEB-4818: 412040 is the server's own Day & Time check — show which rule failed */
                if (response.sub_code == 412040) {
                    self.SSAlertService.parseAndDisplayServerError(response);
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Key handover settings updated successfully.');
            self.settingsEditMode = {};
            self.getPropertySettings();
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
    }

    isValidSettingsInput() {
        const self = this;

        self.keyHandoverSettingsErrors = {};

        let params = self.keyHandoverSettingsParams.value;
        let isValid = true;

        /**
         * WEB-4480: only checked when saving this section, as in the app, so a value saved over a
         * limit before this change cannot block saving the other sections. All three stay optional.
         */
        if (self.editType == 'CONTACT_DETAILS') {
            let contact = params.contact_details || {};

            if (self.exceedsMaxLength(contact.name, self.CONTACT_NAME_MAX_LENGTH)) {
                self.keyHandoverSettingsErrors.name = self.maxLengthMessage(self.CONTACT_NAME_MAX_LENGTH);
                isValid = false;
            }

            if (self.exceedsMaxLength(contact.email, self.CONTACT_EMAIL_MAX_LENGTH)) {
                self.keyHandoverSettingsErrors.email = self.maxLengthMessage(self.CONTACT_EMAIL_MAX_LENGTH);
                isValid = false;
            } else if (contact.email && !self.SSUtilService.validateEmail(contact.email)) {
                self.keyHandoverSettingsErrors.email = "Please enter a valid email.";
                isValid = false;
            } else if (self.exceedsEmailLocalPartLength(contact.email)) {
                // Same rule as the "Send a copy to" addresses, so the two email fields agree
                self.keyHandoverSettingsErrors.email = self.localPartMessage();
                isValid = false;
            }

            if (self.exceedsMaxLength(contact.phone, self.CONTACT_PHONE_MAX_LENGTH)) {
                self.keyHandoverSettingsErrors.phone = self.maxLengthMessage(self.CONTACT_PHONE_MAX_LENGTH);
                isValid = false;
            } else if (contact.phone && !self.isValidContactPhone()) {
                self.keyHandoverSettingsErrors.phone = "Invalid Contact No. Please enter the correct contact no.";
                isValid = false;
            }
        }

        /** WEB-4480: length only; the URL format check stays in validateUrl() */
        if (self.editType == 'EXTERNAL_LINKS_SETTINGS') {
            let links = params.external_links || {};

            self.keyHandoverSettingsErrors.external_links = {};
            $.each(['dps', 'pdpa', 'pp', 'tnc'], function (i, key) {
                if (self.exceedsMaxLength(links[key], self.EXTERNAL_LINK_MAX_LENGTH)) {
                    self.keyHandoverSettingsErrors.external_links[key] = self.maxLengthMessage(self.EXTERNAL_LINK_MAX_LENGTH);
                    isValid = false;
                }
            });
        }

        if (self.editType == 'GENERAL_SETTINGS') {
            if (!params.number_of_tables) {
                self.keyHandoverSettingsErrors.number_of_tables = "Please enter no. of slots.";
                isValid = false;
            }
            if (!params.slot_period) {
                self.keyHandoverSettingsErrors.slot_period = "Please enter slot period.";
                isValid = false;
            } else if (params.slot_period && parseInt(params.slot_period) < 30) {
                self.keyHandoverSettingsErrors.slot_period = "Minimum slot period is 30 minutes.";
                isValid = false;
            } else if (params.slot_period && parseInt(params.slot_period) > 180) {
                /** WEB-4818: the server refuses more than 180 with 412040 */
                self.keyHandoverSettingsErrors.slot_period = "Maximum slot period is 180 minutes.";
                isValid = false;
            }
            /** WEB-4818: Max Unit(s) Per Day — blank means no limit */
            if (!self.isValidOptionalMaxPerDay(params.max_units_per_day)) {
                self.keyHandoverSettingsErrors.max_units_per_day = "Please enter 1 or more, or leave blank for no limit.";
                isValid = false;
            }
            if (!params.max_appointment_days) {
                self.keyHandoverSettingsErrors.max_appointment_days = "Please enter max. appointment days.";
                isValid = false;
            }
            /** WEB-4304: blank/0 disables the late-booking-reason prompt; a negative threshold is meaningless */
            if (!self.isValidOptionalCount(params.late_booking_reason_days)) {
                self.keyHandoverSettingsErrors.late_booking_reason_days = "Please enter 0 or more days.";
                isValid = false;
            }
        }

        if (self.editType == 'DAY_TIME_SETTINGS') {

            self.keyHandoverSettingsErrors.week_days = {};
            self.keyHandoverSettingsErrors.special_days = {};

            // User must provide at least one day time
            $.each(params.week_days, function (i, day) {
                self.keyHandoverSettingsErrors.week_days[i] = {};
                self.keyHandoverSettingsErrors.week_days[i].slots = {};

                if (!day.closed) {
                    /** WEB-4304 / WEB-4818: per-weekday overrides (blank = General) */
                    if (!self.validateDayOverrides(day, self.keyHandoverSettingsErrors.week_days[i])) {
                        isValid = false;
                    }

                    $.each(day.slots, function (j, slot) {
                        self.keyHandoverSettingsErrors.week_days[i].slots[j] = {};
                        if (!slot.start_time) {
                            self.keyHandoverSettingsErrors.week_days[i].slots[j].start_time = "Please enter start time.";
                            isValid = false;
                        }
                        if (!slot.end_time) {
                            self.keyHandoverSettingsErrors.week_days[i].slots[j].end_time = "Please enter end time."
                            isValid = false;
                        }

                        /**
                         * WEB-4818: an end before the start is a range running past midnight
                         * (22:00–02:00), which the DMS app saves too. Only equal times are wrong.
                         */
                        if (slot.start_time && slot.end_time && slot.start_time == slot.end_time) {
                            self.keyHandoverSettingsErrors.week_days[i].slots[j].start_time = "Start and end time cannot be the same.";
                            isValid = false;
                        }
                    });
                }
            });

            /** WEB-4818: Special Days — the same rules the server enforces with 412040 */
            let seenDates = {};
            $.each(params.special_days, function (i, special_day) {
                let errors = self.keyHandoverSettingsErrors.special_days[i] = {slots: {}};
                let date = self.SSDateService.parseSettingsDate(special_day.date);

                if (!special_day.date) {
                    errors.date = "Please select a date.";
                    isValid = false;
                } else if (!date) {
                    errors.date = "Please select a valid date.";
                    isValid = false;
                } else if (seenDates[date]) {
                    errors.date = "Only one special day per date.";
                    isValid = false;
                } else {
                    seenDates[date] = true;
                }

                if (special_day.closed) return;

                if (!self.validateDayOverrides(special_day, errors)) {
                    isValid = false;
                }

                $.each(special_day.slots, function (j, slot) {
                    errors.slots[j] = {};
                    if (slot.start_time && !slot.end_time) {
                        errors.slots[j].end_time = "Please enter end time.";
                        isValid = false;
                    } else if (!slot.start_time && slot.end_time) {
                        errors.slots[j].start_time = "Please enter start time.";
                        isValid = false;
                    } else if (slot.start_time && slot.start_time == slot.end_time) {
                        errors.slots[j].start_time = "Start and end time cannot be the same.";
                        isValid = false;
                    }
                });

                // Blank ranges use the weekday's — which only works when that weekday has some
                if (date && !self.SSKeyHandoverScheduleService.filledSlots(special_day.slots).length) {
                    let weekDay = self.SSKeyHandoverScheduleService.weekDayFor(params, moment(date, 'YYYY-MM-DD'));
                    let weekDayHasRanges = weekDay && !weekDay.closed
                        && self.SSKeyHandoverScheduleService.filledSlots(weekDay.slots).length > 0;

                    if (!weekDayHasRanges) {
                        errors.slots_message = "Add at least one Start/End range — this weekday is Closed or has none.";
                        isValid = false;
                    }
                }
            });
        }

        if (self.editType == 'DOCUMENTS_SETTINGS') {
            self.keyHandoverSettingsErrors.documents = {};
            if (params.documents.length) {
                isValid = self.validateDocuments(params);
            } else {
                params.documents = [];
            }
        }

        return isValid;
    }

    validateDocuments(params) {
        const self = this;

        let isValid = true;
        let authLetters = 0;
        let uniqueNames = true;
        let allDocuments = angular.copy(params.documents);

        $.each(params.documents, function (i, document) {
            self.keyHandoverSettingsErrors.documents[i] = {};
            if (!document.type) {
                self.keyHandoverSettingsErrors.documents[i].type = "Please select document type.";
                isValid = false;
            }
            if (!document.name) {
                self.keyHandoverSettingsErrors.documents[i].name = "Please enter document name.";
                isValid = false;
            } else if (self.exceedsMaxLength(document.name, self.DOCUMENT_NAME_MAX_LENGTH)) {
                /** WEB-4480 */
                self.keyHandoverSettingsErrors.documents[i].name = self.maxLengthMessage(self.DOCUMENT_NAME_MAX_LENGTH);
                isValid = false;
            }

            // Document name should be unique
            // Ignore current document name
            allDocuments[i].name = 'temp_ignore';
            if (allDocuments.find(x => x.name == document.name)) {
                uniqueNames = false;
            }
            allDocuments[i].name = document.name;

            if (document.type == self.APPOINTMENT_FILE_TYPE_LETTER_OF_AUTHORISATION)
                authLetters++;
        });

        if (authLetters > 1) {
            self.keyHandoverSettingsErrors.authLetters = "Only 1 authorisation letter allowed.";
            isValid = false;
        }

        if (!uniqueNames) {
            self.keyHandoverSettingsErrors.documentNames = "Please enter unique name for each file.";
            isValid = false;
        }

        return isValid;
    }

    downloadLetter(document) {
        const self = this;

        let url = 'sec/developer/key-handover/appointments/letter-presigned-url';
        let params = { property_id: self.property.id, name: document.name };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            window.open(response.data.presigned_url, '_blank');
        });
    }

    getDefaultSettings(){
        const self = this;

        let settings = {
            name: 'key_handover_settings',
            value: { slots_enabled_after_days: null, amend_booking_count: null, week_days:[], special_days:[], max_units_per_day: null, nominee_authorisation_letter: null }
        };

        let week_days = [
            {id: 0, name: 'Sunday', closed: 1, slots:[{start_time: null, end_time: null}]},
            {id: 1, name: 'Monday', closed: 0, slots:[{start_time: null, end_time: null}]},
            {id: 2, name: 'Tuesday', closed: 0, slots:[{start_time: null, end_time: null}]},
            {id: 3, name: 'Wednesday', closed: 0, slots:[{start_time: null, end_time: null}]},
            {id: 4, name: 'Thursday', closed: 0, slots:[{start_time: null, end_time: null}]},
            {id: 5, name: 'Friday', closed: 0, slots:[{start_time: null, end_time: null}]},
            {id: 6, name: 'Saturday', closed: 0, slots:[{start_time: null, end_time: null}]}
        ];

        settings.value.week_days = week_days;

        settings.value.otp_verification_rescan = false;
        settings.value.otp_verification_relaunch = false;

        settings.value.buyer_docs_visible = false;
        settings.value.representative_docs_visible = false;

        settings.value.buyer_data_visible_during_edit_appointment = false;
        settings.value.buyer_data_visible_during_edit_particulars = false;

        /** WEB-4224: Buyer Validation is opt-in — default OFF for projects with no settings row yet. */
        settings.value.buyer_validation_enabled = false;

        settings.value.documents = [{}];
        settings.value.external_links = {};
        settings.value.push_notifications = {};
        settings.value.email_notifications = {};
        settings.value.additional_requests = {};
        settings.value.event_registration = {};
        settings.value.contact_details = {};

        return settings;
    }

    /**
     * WEB-3538: Coerce every map-type sub-key of key_handover_settings to a plain object ({}).
     *
     * @remarks
     * The BE persists property_settings.value as a raw string (no JSON cast), so whatever shape
     * the FE serialises is exactly what is read back. An empty associative structure can be stored
     * as [] (legacy data / PHP json_encode), and because [] is truthy in JS the old falsy-only
     * guards left it in place — flipping the shape between empty ([]) and populated ({}) states and
     * breaking strongly-typed API consumers (and risking silent data loss, since JSON.stringify
     * drops non-index properties assigned to an array). Calling this at every load / edit / save
     * boundary keeps the three sites from drifting. Extends the WEB-3406 external_links fix to all
     * map fields. Genuine list fields (week_days, special_days, documents, slots) are NOT touched,
     * and mobile_app_time_zone is intentionally excluded (nullable single-select, never an array).
     *
     * @param {Object} value - The key_handover_settings `value` object to normalise (mutated in place).
     * @returns {Object} The same `value` object, for chaining.
     */
    normalizeMapSettings(value){
        if(!value) return value;

        let mapFields = [
            'external_links',
            'push_notifications',
            'email_notifications',
            'additional_requests',
            'event_registration',
            'contact_details'
        ];

        $.each(mapFields, function(index, field){
            if(!value[field] || Array.isArray(value[field])){
                value[field] = {};
            }
        });

        return value;
    }

    /**
     * WEB-4818: The overrides a week day / special day entry sets, for the read-only views,
     * e.g. "2 unit(s) per slot · 30 mins per slot · max 3 unit(s) per day".
     *
     * @remarks
     * "Not set" is an absent key, null or '' and falls back to the weekday / General value,
     * so only the values the entry really carries are listed. A deliberate 0 units per slot
     * is a value, not "not set".
     *
     * @param {Object} entry - A `week_days[n]` or `special_days[n]` entry.
     * @returns {string} The overrides, or '' when the entry sets none.
     */
    formatDayOverrides(entry){
        const self = this;

        if(!entry) return '';

        let schedule = self.SSKeyHandoverScheduleService;
        let parts = [];

        let tables = schedule.optionalCount(entry.number_of_tables);
        let period = schedule.optionalCount(entry.slot_period);
        let maxPerDay = schedule.optionalCount(entry.max_units_per_day);

        if(tables !== null) parts.push(tables + ' unit(s) per slot');
        if(period !== null) parts.push(period + ' mins per slot');
        if(maxPerDay !== null) parts.push('max ' + maxPerDay + ' unit(s) per day');

        return parts.join(' · ');
    }

    /**
     * WEB-4818: What a blank field on special day `special_day` falls back to — that date's
     * weekday value when the weekday is Open, otherwise General. Shown as the placeholder.
     *
     * @param {Object} special_day - A `special_days[n]` edit-buffer entry.
     * @param {string} key - 'number_of_tables', 'slot_period' or 'max_units_per_day'.
     * @returns {string} The fallback for display, or '--' for none ('No limit' for max per day).
     */
    specialDayFallback(special_day, key){
        const self = this;

        let value = self.keyHandoverSettingsParams && self.keyHandoverSettingsParams.value;
        let schedule = self.SSKeyHandoverScheduleService;
        let fallback = null;

        let date = special_day? self.SSDateService.parseSettingsDate(special_day.date) : null;
        let weekDay = date? schedule.weekDayFor(value, moment(date, 'YYYY-MM-DD')) : null;

        if(weekDay && !weekDay.closed){
            fallback = schedule.optionalCount(weekDay[key]);
        }
        if(fallback === null && value){
            fallback = schedule.optionalCount(value[key]);
        }

        return self.formatFallback(fallback, key);
    }

    /**
     * WEB-4818: The General value a blank weekday field falls back to, for its placeholder.
     */
    generalFallback(key){
        const self = this;

        let value = self.keyHandoverSettingsParams && self.keyHandoverSettingsParams.value;

        return self.formatFallback(value? self.SSKeyHandoverScheduleService.optionalCount(value[key]) : null, key);
    }

    formatFallback(fallback, key){
        if(fallback === null) return key == 'max_units_per_day'? 'No limit' : '--';

        return '' + fallback;
    }

    /**
     * WEB-4818: Validate the optional overrides a week day or an On special day can carry.
     * Bounds match the General fields they override, and the server's 412040 checks.
     *
     * @param {Object} entry - A `week_days[n]` or `special_days[n]` edit-buffer entry.
     * @param {Object} errors - Where the field errors are written.
     * @returns {boolean} True when every override is valid.
     */
    validateDayOverrides(entry, errors){
        const self = this;

        let isValid = true;

        if(!self.isValidOptionalCount(entry.number_of_tables)
            || (self.normalizeOptionalCount(entry.number_of_tables) || 0) > 1000){
            errors.number_of_tables = "Please enter a value between 0 and 1000.";
            isValid = false;
        }

        let period = self.normalizeOptionalCount(entry.slot_period);
        if(!self.isValidOptionalCount(entry.slot_period) || (period !== null && (period < 30 || period > 180))){
            errors.slot_period = "Please enter between 30 and 180 minutes.";
            isValid = false;
        }

        if(!self.isValidOptionalMaxPerDay(entry.max_units_per_day)){
            errors.max_units_per_day = "Please enter 1 or more.";
            isValid = false;
        }

        return isValid;
    }

    /**
     * WEB-4818: Max Unit(s) Per Day is optional (blank = no limit / fall back), and at least 1 when set.
     */
    isValidOptionalMaxPerDay(value){
        const self = this;

        if(value === null || value === undefined || value === '') return true;

        return self.isValidOptionalCount(value) && parseInt(value) >= 1;
    }

    /**
     * WEB-4818: Convert a list of `{start_time, end_time}` ranges between stored UTC and the
     * project's timezone, in place.
     *
     * @remarks
     * Both directions use the zone the settings were loaded under ({@link loadedTimeZoneId}),
     * not the one General Settings may have just picked — converting back with a different
     * zone would shift every range by the difference. Today's offset is used both ways, so a
     * value always converts back to exactly what was loaded.
     *
     * @param {Array} slots
     * @param {boolean} toProject - True for UTC → project, false for project → UTC.
     */
    convertSlotTimes(slots, toProject){
        const self = this;

        let schedule = self.SSKeyHandoverScheduleService;
        let convert = toProject
            ? (t) => schedule.utcToProjectHHmm(t, self.loadedTimeZoneId)
            : (t) => schedule.projectToUtcHHmm(t, self.loadedTimeZoneId);

        $.each(slots || [], function(index, slot){
            if(!slot) return;
            slot.start_time = slot.start_time? convert(slot.start_time) : null;
            slot.end_time = slot.end_time? convert(slot.end_time) : null;
        });
    }

    /**
     * WEB-4818: The zone the Day & Time ranges are shown in, for the label beside them.
     */
    getTimeZoneLabel(){
        const self = this;

        return self.loadedTimeZoneId? self.loadedTimeZoneId : 'your browser\'s timezone';
    }

    /**
     * WEB-4304: Validate an optional non-negative count field (capacity overrides, late-reason days).
     *
     * @param {*} value - The raw ng-model value; blank means "not set" and is valid.
     * @returns {boolean} False only when a value was entered and it is not an integer of 0 or more.
     */
    isValidOptionalCount(value){
        if(value === null || value === undefined || value === '') return true;

        let parsed = Number(value);

        return !isNaN(parsed) && parsed >= 0 && parsed % 1 === 0;
    }

    /**
     * WEB-4304: Coerce an optional count to an int, or null when it was left blank.
     *
     * @remarks
     * The BE reads these keys with `is_numeric()`, so '' would be treated as "set but invalid".
     * Normalising to null keeps "blank = fall back to the default" unambiguous in the stored blob.
     *
     * @param {*} value - The raw ng-model value.
     * @returns {number|null} The parsed integer, or null.
     */
    normalizeOptionalCount(value){
        if(value === null || value === undefined || value === '') return null;

        let parsed = parseInt(value);

        return isNaN(parsed)? null : parsed;
    }

    getKeyHandoverSettingsParams(){
        const self = this;

        /**
         * WEB-4818: serialise a copy. This converts times to UTC and rewrites values in place,
         * and the edit buffer has to stay as the user left it: a save the server refuses
         * (412040) is retried from the same buffer, which would otherwise be converted twice.
         */
        let editBuffer = self.keyHandoverSettingsParams;
        self.keyHandoverSettingsParams = angular.copy(editBuffer);

        if(self.keyHandoverSettingsParams.value.week_days){
            $.each(self.keyHandoverSettingsParams.value.week_days, function(index, day){
                day.closed = day.closed? 1 : 0;
                day.slots = day.closed? [] : self.SSKeyHandoverScheduleService.filledSlots(day.slots);
                self.convertSlotTimes(day.slots, false);

                /**
                 * WEB-4304 / WEB-4818: per-weekday overrides — blank falls back to General, and a
                 * closed day stores none, like its slots.
                 */
                day.number_of_tables = day.closed? null : self.normalizeOptionalCount(day.number_of_tables);
                day.slot_period = day.closed? null : self.normalizeOptionalCount(day.slot_period);
                day.max_units_per_day = day.closed? null : self.normalizeOptionalCount(day.max_units_per_day);
            });
        }

        /**
         * WEB-4818: Special Days. An Off day stores only its date — nothing it hides is kept, so
         * switching it On again does not bring back values the user could not see. Blank ranges
         * are dropped: an On day with none uses its weekday's.
         */
        if(Array.isArray(self.keyHandoverSettingsParams.value.special_days)){
            $.each(self.keyHandoverSettingsParams.value.special_days, function(index, special_day){
                let closed = self.SSKeyHandoverScheduleService.isSpecialDayOff(special_day);

                special_day.date = self.SSDateService.formateWithTimeAsNoon(special_day.date) || null;
                special_day.closed = closed? 1 : 0;
                special_day.slots = closed? [] : self.SSKeyHandoverScheduleService.filledSlots(special_day.slots);
                self.convertSlotTimes(special_day.slots, false);

                special_day.number_of_tables = closed? null : self.normalizeOptionalCount(special_day.number_of_tables);
                special_day.slot_period = closed? null : self.normalizeOptionalCount(special_day.slot_period);
                special_day.max_units_per_day = closed? null : self.normalizeOptionalCount(special_day.max_units_per_day);
            });
        }

        /** WEB-4818: project-wide Max Unit(s) Per Day — null means no limit */
        self.keyHandoverSettingsParams.value.max_units_per_day =
            self.normalizeOptionalCount(self.keyHandoverSettingsParams.value.max_units_per_day);

        /** WEB-4304: late-booking-reason threshold and the mark-ready booking-window switch */
        self.keyHandoverSettingsParams.value.late_booking_reason_days =
            self.normalizeOptionalCount(self.keyHandoverSettingsParams.value.late_booking_reason_days);
        self.keyHandoverSettingsParams.value.max_appointment_days_from_ready_date =
            self.max_appointment_days_from_ready_date? 1 : 0;

        self.keyHandoverSettingsParams.value.otp_verification_rescan = self.otp_verification_rescan? 1 : 0;
        self.keyHandoverSettingsParams.value.otp_verification_relaunch = self.otp_verification_relaunch? 1 : 0;

        self.keyHandoverSettingsParams.value.buyer_docs_visible = self.buyer_docs_visible? 1 : 0;
        self.keyHandoverSettingsParams.value.representative_docs_visible = self.representative_docs_visible? 1 : 0;

        self.keyHandoverSettingsParams.value.buyer_data_visible_during_edit_appointment = self.keyHandoverSettingsParams.value.buyer_data_visible_during_edit_appointment? 1 : 0;
        self.keyHandoverSettingsParams.value.buyer_data_visible_during_edit_particulars = self.keyHandoverSettingsParams.value.buyer_data_visible_during_edit_particulars? 1 : 0;

        /**
         * WEB-4224: Buyer Validation switch (key_handover_settings.buyer_validation_enabled).
         * Serialised as 1/0 to match every sibling flag in this blob; the server gate reads it with
         * !empty(), so 0 and an absent key both mean OFF (WEB-4223). Written unconditionally on every
         * save of any section, because getKeyHandoverSettingsParams() posts the WHOLE blob back —
         * leaving it out would drop the key the first time another section is saved.
         */
        self.keyHandoverSettingsParams.value.buyer_validation_enabled = self.keyHandoverSettingsParams.value.buyer_validation_enabled? 1 : 0;

        if(self.keyHandoverSettingsParams.value.nric_passport_buyer){
            self.keyHandoverSettingsParams.value.nric_passport_buyer = self.keyHandoverSettingsParams.value.nric_passport_buyer? 1 : 0;
            self.keyHandoverSettingsParams.value.nric_passport_buyer_required = self.keyHandoverSettingsParams.value.nric_passport_buyer_required? 1 : 0;
            self.keyHandoverSettingsParams.value.nric_passport_buyer_four_character = self.keyHandoverSettingsParams.value.nric_passport_buyer_four_character? 1 : 0;
        }else{
            self.keyHandoverSettingsParams.value.nric_passport_buyer = 0;
            self.keyHandoverSettingsParams.value.nric_passport_buyer_required = 0;
            self.keyHandoverSettingsParams.value.nric_passport_buyer_four_character = 0;
        }

        if(self.keyHandoverSettingsParams.value.nric_passport_authroised_officer){
            self.keyHandoverSettingsParams.value.nric_passport_authroised_officer = self.keyHandoverSettingsParams.value.nric_passport_authroised_officer? 1 : 0;
            self.keyHandoverSettingsParams.value.nric_passport_authroised_officer_required = self.keyHandoverSettingsParams.value.nric_passport_authroised_officer_required? 1 : 0;
            self.keyHandoverSettingsParams.value.nric_passport_authroised_officer_four_character = self.keyHandoverSettingsParams.value.nric_passport_authroised_officer_four_character? 1 : 0;
        }else{
            self.keyHandoverSettingsParams.value.nric_passport_authroised_officer = 0;
            self.keyHandoverSettingsParams.value.nric_passport_authroised_officer_required = 0;
            self.keyHandoverSettingsParams.value.nric_passport_authroised_officer_four_character = 0;
        }

        if(self.keyHandoverSettingsParams.value.slot_times) delete self.keyHandoverSettingsParams.value.slot_times;
        if(self.keyHandoverSettingsParams.value.change_particular_time) delete self.keyHandoverSettingsParams.value.change_particular_time;
        if(self.keyHandoverSettingsParams.value.change_particulars_time) delete self.keyHandoverSettingsParams.value.change_particulars_time;

        if(self.keyHandoverSettingsParams.value.approval_required)
            self.keyHandoverSettingsParams.value.approval_required = self.approval_required_value;

        /** WEB-2906 Keyhandover : DMS : Address Optional and Mandatory Support **/
        if(self.show_address){
            if(self.show_address_required){
                self.keyHandoverSettingsParams.value.address_setting = 30;
            }else{
                self.keyHandoverSettingsParams.value.address_setting = 20;
            }
        }else{
            self.keyHandoverSettingsParams.value.address_setting = 10;
        }

        /** WEB-3538: final safety net — never serialise any map sub-key as [] (extends WEB-3406) */
        self.normalizeMapSettings(self.keyHandoverSettingsParams.value);

        let params = {
            id: self.keyHandoverSettingsParams.id? self.keyHandoverSettingsParams.id : 0,
            name: 'key_handover_settings',
            value: JSON.stringify(self.keyHandoverSettingsParams.value)
        };

        self.keyHandoverSettingsParams = editBuffer;

        return params;
    }

    addWeekSlot(index1){
        const self = this;

        if(!self.keyHandoverSettingsParams.value.week_days[index1].slots)
            self.keyHandoverSettingsParams.value.week_days[index1].slots = [];

        self.keyHandoverSettingsParams.value.week_days[index1].slots.push({
            start_time: null, end_time: null
        });
    }

    removeWeekSlot(index1){
        const self = this;

        if(self.keyHandoverSettingsParams.value.week_days[index1].slots.length > 1){
            self.keyHandoverSettingsParams.value.week_days[index1].slots.pop();
        }
    }

    /** WEB-4818: a new special day starts Off — the switch has to be turned On to open the date */
    addSpecialDay(){
        const self = this;

        self.keyHandoverSettingsParams.value.special_days.push({
            date: null,
            closed: true,
            slots: [{start_time: null, end_time: null}],
            number_of_tables: null,
            slot_period: null,
            max_units_per_day: null
        });

        self.$timeout(function(){
            let index = self.keyHandoverSettingsParams.value.special_days.length-1;
            if($(".sd_"+ index).length){
                $(".sd_"+ index).datepicker("option", "dateFormat", "dd/mm/yy");
            }
        });
    }

    removeSpecialDay(index){
        const self = this;

        self.keyHandoverSettingsParams.value.special_days.splice(index, 1);

        // Errors are keyed by row, so the remaining rows' messages would point at the wrong ones
        if(self.keyHandoverSettingsErrors) self.keyHandoverSettingsErrors.special_days = {};
    }

    toggleSpecialDay(index){
        const self = this;

        let special_day = self.keyHandoverSettingsParams.value.special_days[index];

        special_day.closed = !special_day.closed;
        if(!special_day.closed && (!special_day.slots || !special_day.slots.length)){
            special_day.slots = [{start_time: null, end_time: null}];
        }
    }

    addSpecialDaySlot(index){
        const self = this;

        self.keyHandoverSettingsParams.value.special_days[index].slots.push({start_time: null, end_time: null});
    }

    removeSpecialDaySlot(index){
        const self = this;

        let slots = self.keyHandoverSettingsParams.value.special_days[index].slots;
        if(slots.length > 1){
            slots.pop();
        }
    }

    // ---------  Key Handover Settings Section: END -------

    getFilePlaceholderUrl(document){
        const self = this;

        if(!document) return '/images/pdf-placeholder.png';

        return '/images/' + (document.format == 'pdf'? 'pdf-placeholder.png':'placeholder.jpg');
    }

    addNewDocument(){
        const self = this;

        self.keyHandoverSettingsParams.value.documents.push({});
    }

    removeDocument(index){
        const self = this;

        if(self.keyHandoverSettingsParams.value.documents.length == 1){
            self.keyHandoverSettingsParams.value.documents[index] = {};
            return;
        }

        let documents = [];

        delete self.keyHandoverSettingsParams.value.documents[index];
        $.each(self.keyHandoverSettingsParams.value.documents, function(i, document){
            if(document)
                documents.push(document);
        });

        self.keyHandoverSettingsParams.value.documents = documents;
    }

    initDocumentTypes(){
        const self = this;

        self.documentTypes = [
            {id: self.APPOINTMENT_FILE_TYPE_LETTER_OF_AUTHORISATION, name: "Letter of authorisation"},
            {id: self.APPOINTMENT_FILE_TYPE_OTHERS, name: "Other Letter"}
        ];
    }

    initDocumentRoles(){
        const self = this;

        self.documentRoles = [
            {id: 0, name: "Both"},
            {id: 10, name: "Buyer"},
            {id: 20, name: "Authorised Representative"}
        ];
    }

    initEmailTemplateConstants(){
        const self = this;

        self.emailTemplateTypes = [
            {id: self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_BOOKING_SUBMISSION, name: "Booking Submission (Verification pending)"},
            {id: self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_CONFIRMATION, name: "Appointment Confirmation"},
            {id: self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_CANCELED, name: "Appointment Cancellation"},
            {id: self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_EXPIRY, name: "Appointment Expiry"},
            {id: self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_RESCHEDULE, name: "On Re-schedule after Appointment Cancelled/Expired"},
            {id: self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_UPDATED, name: "On Update/amend of Buyer Particulars/Appointment time slot"},
            {id: self.EMAIL_TEMPLATE_KEY_HANDOVER_APPOINTMENT_UNIT_READY, name: 'Unit Ready'}
        ];
    }

    getTypeName(type){
        const self = this;

        if(!type) return '--';

        let document = self.documentTypes.find(x => x.id == type);
        if(document) return document.name;

        return '--';
    }

    getRoleName(role){
        const self = this;

        if(!role) return '--';

        let document = self.documentRoles.find(x => x.id == role);
        if(document) return document.name;

        return '--';
    }

    refreshDate(){
        const self = this;

        // https://api.jqueryui.com/datepicker/#option-minDate
        $('.date-input').datepicker("option", "dateFormat", "dd/mm/yy");
    }

    downloadAdditionalRequestsData(requestType) {
        const self = this;

        let url = self.SSHttpService.getReportURL('api/reports/key-handover-appointment-additional-requests');
        url += '&property_id=' + self.property.id;
        url += '&request_type=' + requestType;

        let url_ping = window.open(url, '_blank');

        if (url_ping) {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }

    /** WEB-2847 KeyHandover: New Forms and External Links Settings - START **/
    updateEventRegistrationTemplate(){
        const self = this;
        self.eventRegTemContents = '';
        if(self.keyHandoverSettingsParams.value.event_registration.form_template_file_uri ){
            self.getPresingedEventRegistrationTemplateUrl('form_template_file_uri',false);
        }else{
            self.openEditorForEventRegistration('');
        }

    }

    openEditorForEventRegistration(content){
        const self = this;
        self.eventRegTemContents = angular.copy(content);
        // Init Froala Editor
        self.editorEventRegistration = new FroalaEditor('#froala-editor-event-registration', {
            key: self.EDITOR_API_KEY,
            charCounterCount: false,
            placeholderText: '',
            fullPage: true

        }, function(){
        });
        self.eventRegistrationEditMode = true;
        $('#eventRegistrationModal').modal('show');

        self.$timeout(function () {
            if(self.eventRegTemContents){
                // WEB-3597 — allow-list sanitise the stored email-template HTML before trusting it.
                self.eventRegTemContents = self.$sce.trustAsHtml(window.ssSanitizeHtml(self.eventRegTemContents));
            }
            self.editorEventRegistration.html.set(self.eventRegTemContents && self.eventRegTemContents !== '' ? self.eventRegTemContents.$$unwrapTrustedValue() : '');
            self.$scope.$apply();
        });
    }

    saveEventRegistrationTemplate(){
        const self = this;
        let content = self.editorEventRegistration.html.get(true);
        if (content && content !== '') {
            content = _.unescape(content);
            // Create blob and upload
            let blob = new Blob([content], {type: "text/html;charset=utf-8"});
            let file_name = 'property_event_registration_' + self.property.id + '_document.html';
            self.uploadFile(blob, file_name);
        }else if(self.keyHandoverSettingsParams.value.event_registration.form_template_file_uri){
            loading(true);
            let url = 'sec/developer/key-handover/delete-file-from-aws';
            self.SSHttpService.getAPIRequest(url, {
                name: 'form_template_file_uri',
                property_id: self.property.id
            }).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                else{
                    $('#eventRegistrationModal').modal('hide');
                    self.keyHandoverSettingsParams.value.event_registration.form_template_file_uri = '';
                }
            });
        }else{
            $('#eventRegistrationModal').modal('hide');
        }
    }

    uploadFile(file, file_name) {
        const self = this;

        let policyUrl = 'sec/developer/key-handover/appointments/s3-policy-document?property_id='+self.property.id;

        file["name"] = file_name;

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {

            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            loading(false);
            $('#eventRegistrationModal').modal('hide');
            self.keyHandoverSettingsParams.value.event_registration.form_template_file_uri = response.config.data.key;
        }, file_name);
    }

    uploadEventRegistrationImage(file){
        const self = this;

        let uri = self.keyHandoverSettingsParams.value.event_registration.banner_image_file_uri;

        if (!file) return;
        let fileFormat = null;

        if (file.type.indexOf("image") !== -1) {
            fileFormat = "image";
        } else {
            self.SSAlertService.danger('Error!', 'Please upload image file only');
            return;
        }

        let policyUrl = 'sec/developer/key-handover/appointments/s3-policy-document?property_id='+self.property.id+"&is_public=1";

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.keyHandoverSettingsParams.value.event_registration.banner_image_file_uri = response.config.data.key;
            self.banner_image_file_url = self.SSAppService.getAssetUrl(response.config.data.key);
        });
    }

    removeEventRegistrationImage(){
        const self = this;
        self.event_registration_banner_image = self.key_handover_settings.value.event_registration.banner_image_file_uri;
        self.key_handover_settings.value.event_registration.banner_image_file_uri = null;
        self.keyHandoverSettingsParams.value.event_registration.banner_image_file_uri = null;
        self.banner_image_file_url = null;
    }

    getPresingedEventRegistrationTemplateUrl(name_field, openNewTab) {
        const self = this;
        if((self.keyHandoverSettingsParams && self.keyHandoverSettingsParams.value.event_registration.form_template_file_uri) || (self.key_handover_settings && self.key_handover_settings.value.event_registration.form_template_file_uri)){
            let url = 'sec/developer/key-handover/appointments/event-form-html-presigned-url';
            let params = { property_id: self.property.id, name: name_field};
            self.eventRegistrationEditMode = false;
            self.eventRegistrationViewMode = false;
            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                self.eventRegistrationTemplatePresignedUrl = response.data.presigned_url;
                if(openNewTab){
                    self.eventRegistrationViewMode = true;
                    self.$timeout(function () {
                        $('#eventRegistrationModal').modal('show');
                        $('#event_registration_iframe_view').empty();
                        $('#event_registration_iframe_view').html('<iframe style="width:100%; height: calc(100vh - 200px);" src="' + self.eventRegistrationTemplatePresignedUrl + '"></iframe>');
                        self.$scope.$apply();
                    });
                }
                else{
                    loading(true);
                    $.get(self.eventRegistrationTemplatePresignedUrl, function (data) {
                        loading(false);
                        try {
                            self.openEditorForEventRegistration(data);
                        } catch (ex) {
                            console.log(ex);
                        }
                    });
                }
            });
        }else{
            self.openEditorForEventRegistration('');
        }

    }
    renderHtml (content) {
        const self = this;
        // WEB-3597 — allow-list sanitise rich text before trusting it for ng-bind-html.
        return self.$sce.trustAsHtml(window.ssSanitizeHtml(content));
    };

    downloadEventRegistrationReport(requestType) {
        const self = this;

        let url = self.SSHttpService.getReportURL('api/reports/key-handover-appointment-additional-requests-event');
        url += '&property_id=' + self.property.id;
        url += '&request_type=' + requestType;

        let url_ping = window.open(url, '_blank');

        if (url_ping) {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }

    isEventRegistrationEnabled() {
        const self = this;

        let isEnabled = false;
        if(self.settingsEditMode && self.settingsEditMode['EVENT_REGISTRATION']){
            if(self.keyHandoverSettingsParams.value.event_registration.enable) {
                isEnabled = true;
            }
        } else if(self.key_handover_settings &&
            self.key_handover_settings.value &&
            self.key_handover_settings.value.event_registration &&
            self.key_handover_settings.value.event_registration.enable){
            isEnabled = true;
        }
        return isEnabled;
    }
    /** WEB-2847 KeyHandover: New Forms and External Links Settings - END **/
}

PropertyKeyHandoverSettingsController.$inject = ['$scope', '$parse', '$timeout', '$sce', 'SSHttpService', 'SSAwsService', 'SSConfigService', 'SSUtilService', 'SSDateService', 'SSAlertService', 'SSUserService', 'OTPService', 'SSConfirmationService', 'SSAppService', 'SSKeyHandoverScheduleService'];
app.controller('PropertyKeyHandoverSettingsController', PropertyKeyHandoverSettingsController);

// WEB-4411/WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js.
// A copy here would link it a second time on every element.

app.directive("timepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "timepicker()" METHOD USING THE "element" OBJECT.
        element.timepicker();
    }

    return {
        require: 'ngModel',
        link: link
    };
});

